import { render } from "./ViewTasks.vue?vue&type=template&id=0b01236b"
import script from "./ViewTasks.vue?vue&type=script&lang=js"
export * from "./ViewTasks.vue?vue&type=script&lang=js"

import "./ViewTasks.vue?vue&type=style&index=0&id=0b01236b&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__